import { render, staticRenderFns } from "./RmpFormCol.vue?vue&type=template&id=5bfaabeb"
import script from "./RmpFormCol.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpFormCol.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports